/* eslint-disable */
// tslint:disable
/**
 * Кабинет муниципалитета
 * todo
 *
 * OpenAPI spec version: 1.6.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import { BASE_PATH, COLLECTION_FORMATS, FetchAPI, FetchArgs, BaseAPI, RequiredError, defaultFetch } from "./runtime";
import { Api } from "./models";

export type FactoryFunction<T> = (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) => T;

/**
 * DefaultReportsParamsApi - fetch parameter creator
 * @export
 */
export const DefaultReportsParamsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDefaultParamsData(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/default_reports_params`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * DefaultReportsParamsApi - functional programming interface
 * @export
 */
export const DefaultReportsParamsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDefaultParamsData(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetDefaultParamsData200Response> {
			const localVarFetchArgs = DefaultReportsParamsApiFetchParamCreator(configuration).getDefaultParamsData(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * DefaultReportsParamsApi - factory interface
 * @export
 */
export const DefaultReportsParamsApiFactory: FactoryFunction<DefaultReportsParamsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new DefaultReportsParamsApi(configuration, basePath, fetch);
};

/**
 * DefaultReportsParamsApi - object-oriented interface
 * @export
 * @class DefaultReportsParamsApi
 * @extends {BaseAPI}
 */
export class DefaultReportsParamsApi extends BaseAPI {
	/**
	 * <p>Параметры по умолчанию для выпадашек</p>
	 * @summary Параметры по умолчанию для выпадашек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getDefaultParamsData(options?: RequestInit) {
		return DefaultReportsParamsApiFp(this.configuration).getDefaultParamsData(options)(this.fetch, this.basePath);
	}

}
/**
 * DigitalSchoolsApi - fetch parameter creator
 * @export
 */
export const DigitalSchoolsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {string} [school] <p>school title</p>
		 * @param {number} [parallel] <p>parallel</p>
		 * @param {number} [municipalityId] <p>municipality_id</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDigitalSchoolXlsx(school: string | undefined, parallel: number | undefined, municipalityId: number | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/digital_schools/download`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (school !== undefined) {
				localVarQueryParameter.append('school', String(school));
			}

			if (parallel !== undefined) {
				localVarQueryParameter.append('parallel', String(parallel));
			}

			if (municipalityId !== undefined) {
				localVarQueryParameter.append('municipality_id', String(municipalityId));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Получение списка школ с сервисом цифровая школа</p>
		 * @summary Получение списка школ с сервисом цифровая школа
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getInformation(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/digital_schools`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Возвращает дату подлючени к цифровой школе, количесво учителей и учеников участвующих в программе</p>
		 * @summary Возвращает дату подлючени к цифровой школе
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getIntroduceInformation(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/digital_schools/introductions`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Возвращает список доступных значений для скачивания xlsx файла</p>
		 * @summary Список доступных значений для скачивания xlsx файла
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParamsXSL(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/digital_schools/download_params`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * DigitalSchoolsApi - functional programming interface
 * @export
 */
export const DigitalSchoolsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {string} [school] <p>school title</p>
		 * @param {number} [parallel] <p>parallel</p>
		 * @param {number} [municipalityId] <p>municipality_id</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDigitalSchoolXlsx(school: string | undefined, parallel: number | undefined, municipalityId: number | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = DigitalSchoolsApiFetchParamCreator(configuration).getDigitalSchoolXlsx(school, parallel, municipalityId, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Получение списка школ с сервисом цифровая школа</p>
		 * @summary Получение списка школ с сервисом цифровая школа
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getInformation(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetInformation200Response[]> {
			const localVarFetchArgs = DigitalSchoolsApiFetchParamCreator(configuration).getInformation(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Возвращает дату подлючени к цифровой школе, количесво учителей и учеников участвующих в программе</p>
		 * @summary Возвращает дату подлючени к цифровой школе
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getIntroduceInformation(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetIntroduceInformation200Response> {
			const localVarFetchArgs = DigitalSchoolsApiFetchParamCreator(configuration).getIntroduceInformation(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Возвращает список доступных значений для скачивания xlsx файла</p>
		 * @summary Список доступных значений для скачивания xlsx файла
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParamsXSL(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetParamsXSL200Response> {
			const localVarFetchArgs = DigitalSchoolsApiFetchParamCreator(configuration).getParamsXSL(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * DigitalSchoolsApi - factory interface
 * @export
 */
export const DigitalSchoolsApiFactory: FactoryFunction<DigitalSchoolsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new DigitalSchoolsApi(configuration, basePath, fetch);
};

/**
 * DigitalSchoolsApi - object-oriented interface
 * @export
 * @class DigitalSchoolsApi
 * @extends {BaseAPI}
 */
export class DigitalSchoolsApi extends BaseAPI {
	/**
	 * <p>Выгрузка отчета</p>
	 * @summary Выгрузка отчета
	 * @param {string} [school] <p>school title</p>
	 * @param {number} [parallel] <p>parallel</p>
	 * @param {number} [municipalityId] <p>municipality_id</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getDigitalSchoolXlsx(school: string | undefined, parallel: number | undefined, municipalityId: number | undefined, options?: RequestInit) {
		return DigitalSchoolsApiFp(this.configuration).getDigitalSchoolXlsx(school, parallel, municipalityId, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Получение списка школ с сервисом цифровая школа</p>
	 * @summary Получение списка школ с сервисом цифровая школа
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getInformation(options?: RequestInit) {
		return DigitalSchoolsApiFp(this.configuration).getInformation(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Возвращает дату подлючени к цифровой школе, количесво учителей и учеников участвующих в программе</p>
	 * @summary Возвращает дату подлючени к цифровой школе
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getIntroduceInformation(options?: RequestInit) {
		return DigitalSchoolsApiFp(this.configuration).getIntroduceInformation(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Возвращает список доступных значений для скачивания xlsx файла</p>
	 * @summary Список доступных значений для скачивания xlsx файла
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getParamsXSL(options?: RequestInit) {
		return DigitalSchoolsApiFp(this.configuration).getParamsXSL(options)(this.fetch, this.basePath);
	}

}
/**
 * DistanceLearningsApi - fetch parameter creator
 * @export
 */
export const DistanceLearningsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Выгрузка отчета о использовании сервисов дист. образования</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDownloadLink(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/distance_learnings/download`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Дата начала, количество студентов, количество учителей</p>
		 * @summary Общие данные
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getIntroductionForActualService(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/distance_learnings/introductions`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * DistanceLearningsApi - functional programming interface
 * @export
 */
export const DistanceLearningsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Выгрузка отчета о использовании сервисов дист. образования</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDownloadLink(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = DistanceLearningsApiFetchParamCreator(configuration).getDownloadLink(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Дата начала, количество студентов, количество учителей</p>
		 * @summary Общие данные
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getIntroductionForActualService(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetIntroductionForActualService200Response> {
			const localVarFetchArgs = DistanceLearningsApiFetchParamCreator(configuration).getIntroductionForActualService(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * DistanceLearningsApi - factory interface
 * @export
 */
export const DistanceLearningsApiFactory: FactoryFunction<DistanceLearningsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new DistanceLearningsApi(configuration, basePath, fetch);
};

/**
 * DistanceLearningsApi - object-oriented interface
 * @export
 * @class DistanceLearningsApi
 * @extends {BaseAPI}
 */
export class DistanceLearningsApi extends BaseAPI {
	/**
	 * <p>Выгрузка отчета о использовании сервисов дист. образования</p>
	 * @summary Выгрузка отчета
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getDownloadLink(options?: RequestInit) {
		return DistanceLearningsApiFp(this.configuration).getDownloadLink(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Дата начала, количество студентов, количество учителей</p>
	 * @summary Общие данные
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getIntroductionForActualService(options?: RequestInit) {
		return DistanceLearningsApiFp(this.configuration).getIntroductionForActualService(options)(this.fetch, this.basePath);
	}

}
/**
 * KnowledgeMonitoringApi - fetch parameter creator
 * @export
 */
export const KnowledgeMonitoringApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>XLSX c количествами учеников и учителей принявших участие в тестах в разных паралеллях, стадиях тестов, школах</p>
		 * @summary Отдает отчет по участникам теста
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParticipantsReportXlsx(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_participants/report_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>XLSX c показателями выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Отдает отчет по процентам выполнения тестов теста
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProgressesReportXlsx(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_progresses/report_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
		 * @summary Показатели участия в тестах
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestParticipantsForMunicipality(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_participants/for_municipality`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, муниципалитетах для региона</p>
		 * @summary Показатели участия в тестах для региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestParticipantsForRegion(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_participants/for_region`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Проценты правильно выполненных тестов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestProgressesForMunicipality(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_progresses/for_municipality`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Проценты правильно выполненных тестов для региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestProgressesForRegion(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_progresses/for_region`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
		 * @summary Список тестов мониторинга знаний
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestsList(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/test_lists`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Общее кол-во учеников и учителей, участвовавших в тестах по всему муниципалитету (региону)</p>
		 * @summary Общие показатели по всему муниципалитету или региону
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTotals(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/knowledge_monitoring/totals`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * KnowledgeMonitoringApi - functional programming interface
 * @export
 */
export const KnowledgeMonitoringApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>XLSX c количествами учеников и учителей принявших участие в тестах в разных паралеллях, стадиях тестов, школах</p>
		 * @summary Отдает отчет по участникам теста
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParticipantsReportXlsx(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getParticipantsReportXlsx(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>XLSX c показателями выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Отдает отчет по процентам выполнения тестов теста
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getProgressesReportXlsx(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getProgressesReportXlsx(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
		 * @summary Показатели участия в тестах
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestParticipantsForMunicipality(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TestParticipantsForMunicipality> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTestParticipantsForMunicipality(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, муниципалитетах для региона</p>
		 * @summary Показатели участия в тестах для региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestParticipantsForRegion(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TestParticipantsForRegion> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTestParticipantsForRegion(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Проценты правильно выполненных тестов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestProgressesForMunicipality(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TestProgressesForMunicipality> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTestProgressesForMunicipality(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
		 * @summary Проценты правильно выполненных тестов для региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestProgressesForRegion(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TestProgressesForRegion> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTestProgressesForRegion(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
		 * @summary Список тестов мониторинга знаний
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTestsList(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetTestsList200Response[]> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTestsList(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Общее кол-во учеников и учителей, участвовавших в тестах по всему муниципалитету (региону)</p>
		 * @summary Общие показатели по всему муниципалитету или региону
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTotals(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetTotals200Response> {
			const localVarFetchArgs = KnowledgeMonitoringApiFetchParamCreator(configuration).getTotals(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * KnowledgeMonitoringApi - factory interface
 * @export
 */
export const KnowledgeMonitoringApiFactory: FactoryFunction<KnowledgeMonitoringApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new KnowledgeMonitoringApi(configuration, basePath, fetch);
};

/**
 * KnowledgeMonitoringApi - object-oriented interface
 * @export
 * @class KnowledgeMonitoringApi
 * @extends {BaseAPI}
 */
export class KnowledgeMonitoringApi extends BaseAPI {
	/**
	 * <p>XLSX c количествами учеников и учителей принявших участие в тестах в разных паралеллях, стадиях тестов, школах</p>
	 * @summary Отдает отчет по участникам теста
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getParticipantsReportXlsx(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getParticipantsReportXlsx(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>XLSX c показателями выполнения учениками тестов в разных паралеллях, тестах, школах</p>
	 * @summary Отдает отчет по процентам выполнения тестов теста
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getProgressesReportXlsx(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getProgressesReportXlsx(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
	 * @summary Показатели участия в тестах
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTestParticipantsForMunicipality(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTestParticipantsForMunicipality(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, муниципалитетах для региона</p>
	 * @summary Показатели участия в тестах для региона
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTestParticipantsForRegion(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTestParticipantsForRegion(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
	 * @summary Проценты правильно выполненных тестов
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTestProgressesForMunicipality(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTestProgressesForMunicipality(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Какие показатели выполнения учениками тестов в разных паралеллях, тестах, школах</p>
	 * @summary Проценты правильно выполненных тестов для региона
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTestProgressesForRegion(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTestProgressesForRegion(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Сколько учеников и учителей приняло участие в разных паралеллях, тестах, школах</p>
	 * @summary Список тестов мониторинга знаний
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTestsList(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTestsList(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Общее кол-во учеников и учителей, участвовавших в тестах по всему муниципалитету (региону)</p>
	 * @summary Общие показатели по всему муниципалитету или региону
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTotals(options?: RequestInit) {
		return KnowledgeMonitoringApiFp(this.configuration).getTotals(options)(this.fetch, this.basePath);
	}

}
/**
 * MunicipalitiesApi - fetch parameter creator
 * @export
 */
export const MunicipalitiesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getListOfMunicipalitets(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/municipalities`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * MunicipalitiesApi - functional programming interface
 * @export
 */
export const MunicipalitiesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getListOfMunicipalitets(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetListOfMunicipalitets200Response[]> {
			const localVarFetchArgs = MunicipalitiesApiFetchParamCreator(configuration).getListOfMunicipalitets(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * MunicipalitiesApi - factory interface
 * @export
 */
export const MunicipalitiesApiFactory: FactoryFunction<MunicipalitiesApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new MunicipalitiesApi(configuration, basePath, fetch);
};

/**
 * MunicipalitiesApi - object-oriented interface
 * @export
 * @class MunicipalitiesApi
 * @extends {BaseAPI}
 */
export class MunicipalitiesApi extends BaseAPI {
	/**
	 * <p>Параметры по умолчанию для выпадашек</p>
	 * @summary Параметры по умолчанию для выпадашек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getListOfMunicipalitets(options?: RequestInit) {
		return MunicipalitiesApiFp(this.configuration).getListOfMunicipalitets(options)(this.fetch, this.basePath);
	}

}
/**
 * MunicipalitySchoolsApi - fetch parameter creator
 * @export
 */
export const MunicipalitySchoolsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalitySchoolsData(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/municipality_schools`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * MunicipalitySchoolsApi - functional programming interface
 * @export
 */
export const MunicipalitySchoolsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalitySchoolsData(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetMunicipalitySchoolsData200Response> {
			const localVarFetchArgs = MunicipalitySchoolsApiFetchParamCreator(configuration).getMunicipalitySchoolsData(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * MunicipalitySchoolsApi - factory interface
 * @export
 */
export const MunicipalitySchoolsApiFactory: FactoryFunction<MunicipalitySchoolsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new MunicipalitySchoolsApi(configuration, basePath, fetch);
};

/**
 * MunicipalitySchoolsApi - object-oriented interface
 * @export
 * @class MunicipalitySchoolsApi
 * @extends {BaseAPI}
 */
export class MunicipalitySchoolsApi extends BaseAPI {
	/**
	 * <p>Параметры по умолчанию для выпадашек</p>
	 * @summary Параметры по умолчанию для выпадашек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getMunicipalitySchoolsData(options?: RequestInit) {
		return MunicipalitySchoolsApiFp(this.configuration).getMunicipalitySchoolsData(options)(this.fetch, this.basePath);
	}

}
/**
 * OlympiadsApi - fetch parameter creator
 * @export
 */
export const OlympiadsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Рейтинги по муникам</p>
		 * @summary Рейтинги по муникам
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalityRatingsByOlympiads(yearLearn: string, olympType: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'yearLearn' is not null or undefined
			if (yearLearn === null || yearLearn === undefined) {
				throw new RequiredError('yearLearn', 'Required parameter yearLearn was null or undefined when calling getMunicipalityRatingsByOlympiads.');
			}
			// verify required parameter 'olympType' is not null or undefined
			if (olympType === null || olympType === undefined) {
				throw new RequiredError('olympType', 'Required parameter olympType was null or undefined when calling getMunicipalityRatingsByOlympiads.');
			}
			let localVarPath = `/api/v3/olympiads/municipality_ratings`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (yearLearn !== undefined) {
				localVarQueryParameter.append('year_learn', String(yearLearn));
			}

			if (olympType !== undefined) {
				localVarQueryParameter.append('olymp_type', String(olympType));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета по олимпиаде</p>
		 * @summary Выгрузка отчета по олимпиаде
		 * @param {string} olympiadId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadReportById(olympiadId: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'olympiadId' is not null or undefined
			if (olympiadId === null || olympiadId === undefined) {
				throw new RequiredError('olympiadId', 'Required parameter olympiadId was null or undefined when calling getOlyimpiadReportById.');
			}
			let localVarPath = `/api/v3/olympiads/{olympiad_id}/get_xlsx`
				.replace('{olympiad_id}', encodeURIComponent(String(olympiadId)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по олимпиадам за год</p>
		 * @summary Данные по олимпиадам за год
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsList(yearLearn: string, olympType: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'yearLearn' is not null or undefined
			if (yearLearn === null || yearLearn === undefined) {
				throw new RequiredError('yearLearn', 'Required parameter yearLearn was null or undefined when calling getOlyimpiadsList.');
			}
			// verify required parameter 'olympType' is not null or undefined
			if (olympType === null || olympType === undefined) {
				throw new RequiredError('olympType', 'Required parameter olympType was null or undefined when calling getOlyimpiadsList.');
			}
			let localVarPath = `/api/v3/olympiads`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (yearLearn !== undefined) {
				localVarQueryParameter.append('year_learn', String(yearLearn));
			}

			if (olympType !== undefined) {
				localVarQueryParameter.append('olymp_type', String(olympType));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по олимпиадам за год по муниципалитетам</p>
		 * @summary Данные по олимпиадам за год по муниципалитетам
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsListForRegion(yearLearn: string, olympType: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'yearLearn' is not null or undefined
			if (yearLearn === null || yearLearn === undefined) {
				throw new RequiredError('yearLearn', 'Required parameter yearLearn was null or undefined when calling getOlyimpiadsListForRegion.');
			}
			// verify required parameter 'olympType' is not null or undefined
			if (olympType === null || olympType === undefined) {
				throw new RequiredError('olympType', 'Required parameter olympType was null or undefined when calling getOlyimpiadsListForRegion.');
			}
			let localVarPath = `/api/v3/olympiads/index_for_region`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (yearLearn !== undefined) {
				localVarQueryParameter.append('year_learn', String(yearLearn));
			}

			if (olympType !== undefined) {
				localVarQueryParameter.append('olymp_type', String(olympType));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета по олимпиадам</p>
		 * @summary Выгрузка отчета по олимпиадам
		 * @param {string} fromDate <p>начало периода</p>
		 * @param {string} endDate <p>конец периода</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsReportForPeriod(fromDate: string, endDate: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'fromDate' is not null or undefined
			if (fromDate === null || fromDate === undefined) {
				throw new RequiredError('fromDate', 'Required parameter fromDate was null or undefined when calling getOlyimpiadsReportForPeriod.');
			}
			// verify required parameter 'endDate' is not null or undefined
			if (endDate === null || endDate === undefined) {
				throw new RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getOlyimpiadsReportForPeriod.');
			}
			let localVarPath = `/api/v3/olympiads/report_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (fromDate !== undefined) {
				localVarQueryParameter.append('from_date', String(fromDate));
			}

			if (endDate !== undefined) {
				localVarQueryParameter.append('end_date', String(endDate));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка списка олимпиад</p>
		 * @summary Выгрузка списка олимпиад
		 * @param {string} fileName <p>file_name</p>
		 * @param {string} yearLearn <p>year_learn</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlympiadsPdf(fileName: string, yearLearn: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'fileName' is not null or undefined
			if (fileName === null || fileName === undefined) {
				throw new RequiredError('fileName', 'Required parameter fileName was null or undefined when calling getOlympiadsPdf.');
			}
			// verify required parameter 'yearLearn' is not null or undefined
			if (yearLearn === null || yearLearn === undefined) {
				throw new RequiredError('yearLearn', 'Required parameter yearLearn was null or undefined when calling getOlympiadsPdf.');
			}
			let localVarPath = `/api/content/public/olympiads/pdf/{year_learn}/{file_name}`
				.replace('{file_name}', encodeURIComponent(String(fileName)))
				.replace('{year_learn}', encodeURIComponent(String(yearLearn)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по рейтингу олимпиад</p>
		 * @summary Данные по рейтингу олимпиад
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRatingOlympiad(olympIds: string[], options: RequestInit = {}): FetchArgs {
			// verify required parameter 'olympIds' is not null or undefined
			if (olympIds === null || olympIds === undefined) {
				throw new RequiredError('olympIds', 'Required parameter olympIds was null or undefined when calling getRatingOlympiad.');
			}
			let localVarPath = `/api/content/public/olympiads/result`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (olympIds !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of olympIds) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('olympIds', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по рейтингу БКАД</p>
		 * @summary Данные по рейтингу БКАД
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRatingSafenet(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/olympiads/safenet_result`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по результатам олимпиад(включая перечневые)</p>
		 * @summary Данные по результатам олимпиад(включая перечневые)
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiads(olympIds: string[], options: RequestInit = {}): FetchArgs {
			// verify required parameter 'olympIds' is not null or undefined
			if (olympIds === null || olympIds === undefined) {
				throw new RequiredError('olympIds', 'Required parameter olympIds was null or undefined when calling getResultOlympiads.');
			}
			let localVarPath = `/api/content/public/olympiads/result_total`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (olympIds !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of olympIds) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('olympIds', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета со статистикой олимпиады по классам</p>
		 * @summary Выгрузка отчета со статистикой олимпиады по классам
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {Api.GetResultOlympiadsByGradesXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
		 *   <ul>
		 *   <li><code>1</code>: Первый тур завершен.</li>
		 *   <li><code>2</code>: Второй тур завершен.</li>
		 *   </ul>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiadsByGradesXlsx(olympIds: string[], status: Api.GetResultOlympiadsByGradesXlsxStatusEnum | undefined, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'olympIds' is not null or undefined
			if (olympIds === null || olympIds === undefined) {
				throw new RequiredError('olympIds', 'Required parameter olympIds was null or undefined when calling getResultOlympiadsByGradesXlsx.');
			}
			let localVarPath = `/api/content/public/olympiads/result_by_grades_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (olympIds !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of olympIds) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('olympIds', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			if (status !== undefined) {
				localVarQueryParameter.append('status', String(status));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета со статистикой олимпиады по регионам</p>
		 * @summary Выгрузка отчета со статистикой олимпиады по регионам
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {Api.GetResultOlympiadsXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
		 *   <ul>
		 *   <li><code>1</code>: Первый тур завершен.</li>
		 *   <li><code>2</code>: Второй тур завершен.</li>
		 *   </ul>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiadsXlsx(olympIds: string[], status: Api.GetResultOlympiadsXlsxStatusEnum | undefined, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'olympIds' is not null or undefined
			if (olympIds === null || olympIds === undefined) {
				throw new RequiredError('olympIds', 'Required parameter olympIds was null or undefined when calling getResultOlympiadsXlsx.');
			}
			let localVarPath = `/api/content/public/olympiads/result_total_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (olympIds !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of olympIds) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('olympIds', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			if (status !== undefined) {
				localVarQueryParameter.append('status', String(status));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Сводные данные по олимпиадам за выбранный год</p>
		 * @summary Сводные данные по олимпиадам за выбранный год
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTotalStatistic(yearLearn: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'yearLearn' is not null or undefined
			if (yearLearn === null || yearLearn === undefined) {
				throw new RequiredError('yearLearn', 'Required parameter yearLearn was null or undefined when calling getTotalStatistic.');
			}
			let localVarPath = `/api/v3/olympiads/total_statistics`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (yearLearn !== undefined) {
				localVarQueryParameter.append('year_learn', String(yearLearn));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Данные по олимпиадам</p>
		 * @summary Данные по олимпиадам
		 * @param {string[]} [statuses] <p>Список статусов олимпиад (passed, current, future)</p>
		 * @param {string[]} [years] <p>Список годов (например, 2021, 2022)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getUnAuthOlympiads(statuses: string[] | undefined, years: string[] | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/olympiads/index_unauth`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (statuses !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of statuses) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('statuses[]', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			if (years !== undefined) {
				/* array form exploded */
				for (const localVarArrayElement of years) {
					if (localVarArrayElement !== undefined) {
						localVarQueryParameter.append('years[]', localVarArrayElement !== null ? String(localVarArrayElement) : '');
					}
				}
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * OlympiadsApi - functional programming interface
 * @export
 */
export const OlympiadsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Рейтинги по муникам</p>
		 * @summary Рейтинги по муникам
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalityRatingsByOlympiads(yearLearn: string, olympType: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetMunicipalityRatingsByOlympiads200Response[]> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getMunicipalityRatingsByOlympiads(yearLearn, olympType, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета по олимпиаде</p>
		 * @summary Выгрузка отчета по олимпиаде
		 * @param {string} olympiadId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadReportById(olympiadId: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getOlyimpiadReportById(olympiadId, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по олимпиадам за год</p>
		 * @summary Данные по олимпиадам за год
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsList(yearLearn: string, olympType: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetOlyimpiadsList200Response> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getOlyimpiadsList(yearLearn, olympType, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по олимпиадам за год по муниципалитетам</p>
		 * @summary Данные по олимпиадам за год по муниципалитетам
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {string} olympType <p>current passed future</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsListForRegion(yearLearn: string, olympType: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetOlyimpiadsListForRegion200Response> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getOlyimpiadsListForRegion(yearLearn, olympType, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета по олимпиадам</p>
		 * @summary Выгрузка отчета по олимпиадам
		 * @param {string} fromDate <p>начало периода</p>
		 * @param {string} endDate <p>конец периода</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlyimpiadsReportForPeriod(fromDate: string, endDate: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getOlyimpiadsReportForPeriod(fromDate, endDate, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка списка олимпиад</p>
		 * @summary Выгрузка списка олимпиад
		 * @param {string} fileName <p>file_name</p>
		 * @param {string} yearLearn <p>year_learn</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getOlympiadsPdf(fileName: string, yearLearn: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getOlympiadsPdf(fileName, yearLearn, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/pdf') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по рейтингу олимпиад</p>
		 * @summary Данные по рейтингу олимпиад
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRatingOlympiad(olympIds: string[], options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetRatingOlympiad200Response[]> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getRatingOlympiad(olympIds, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по рейтингу БКАД</p>
		 * @summary Данные по рейтингу БКАД
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRatingSafenet(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetRatingSafenet200Response[]> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getRatingSafenet(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по результатам олимпиад(включая перечневые)</p>
		 * @summary Данные по результатам олимпиад(включая перечневые)
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiads(olympIds: string[], options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetResultOlympiads200Response[]> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getResultOlympiads(olympIds, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета со статистикой олимпиады по классам</p>
		 * @summary Выгрузка отчета со статистикой олимпиады по классам
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {Api.GetResultOlympiadsByGradesXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
		 *   <ul>
		 *   <li><code>1</code>: Первый тур завершен.</li>
		 *   <li><code>2</code>: Второй тур завершен.</li>
		 *   </ul>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiadsByGradesXlsx(olympIds: string[], status: Api.GetResultOlympiadsByGradesXlsxStatusEnum | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getResultOlympiadsByGradesXlsx(olympIds, status, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета со статистикой олимпиады по регионам</p>
		 * @summary Выгрузка отчета со статистикой олимпиады по регионам
		 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
		 * @param {Api.GetResultOlympiadsXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
		 *   <ul>
		 *   <li><code>1</code>: Первый тур завершен.</li>
		 *   <li><code>2</code>: Второй тур завершен.</li>
		 *   </ul>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getResultOlympiadsXlsx(olympIds: string[], status: Api.GetResultOlympiadsXlsxStatusEnum | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getResultOlympiadsXlsx(olympIds, status, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Сводные данные по олимпиадам за выбранный год</p>
		 * @summary Сводные данные по олимпиадам за выбранный год
		 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTotalStatistic(yearLearn: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetTotalStatistic200Response> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getTotalStatistic(yearLearn, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Данные по олимпиадам</p>
		 * @summary Данные по олимпиадам
		 * @param {string[]} [statuses] <p>Список статусов олимпиад (passed, current, future)</p>
		 * @param {string[]} [years] <p>Список годов (например, 2021, 2022)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getUnAuthOlympiads(statuses: string[] | undefined, years: string[] | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetUnAuthOlympiads200Response[]> {
			const localVarFetchArgs = OlympiadsApiFetchParamCreator(configuration).getUnAuthOlympiads(statuses, years, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * OlympiadsApi - factory interface
 * @export
 */
export const OlympiadsApiFactory: FactoryFunction<OlympiadsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new OlympiadsApi(configuration, basePath, fetch);
};

/**
 * OlympiadsApi - object-oriented interface
 * @export
 * @class OlympiadsApi
 * @extends {BaseAPI}
 */
export class OlympiadsApi extends BaseAPI {
	/**
	 * <p>Рейтинги по муникам</p>
	 * @summary Рейтинги по муникам
	 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
	 * @param {string} olympType <p>current passed future</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getMunicipalityRatingsByOlympiads(yearLearn: string, olympType: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getMunicipalityRatingsByOlympiads(yearLearn, olympType, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета по олимпиаде</p>
	 * @summary Выгрузка отчета по олимпиаде
	 * @param {string} olympiadId
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getOlyimpiadReportById(olympiadId: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getOlyimpiadReportById(olympiadId, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по олимпиадам за год</p>
	 * @summary Данные по олимпиадам за год
	 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
	 * @param {string} olympType <p>current passed future</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getOlyimpiadsList(yearLearn: string, olympType: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getOlyimpiadsList(yearLearn, olympType, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по олимпиадам за год по муниципалитетам</p>
	 * @summary Данные по олимпиадам за год по муниципалитетам
	 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
	 * @param {string} olympType <p>current passed future</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getOlyimpiadsListForRegion(yearLearn: string, olympType: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getOlyimpiadsListForRegion(yearLearn, olympType, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета по олимпиадам</p>
	 * @summary Выгрузка отчета по олимпиадам
	 * @param {string} fromDate <p>начало периода</p>
	 * @param {string} endDate <p>конец периода</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getOlyimpiadsReportForPeriod(fromDate: string, endDate: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getOlyimpiadsReportForPeriod(fromDate, endDate, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка списка олимпиад</p>
	 * @summary Выгрузка списка олимпиад
	 * @param {string} fileName <p>file_name</p>
	 * @param {string} yearLearn <p>year_learn</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getOlympiadsPdf(fileName: string, yearLearn: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getOlympiadsPdf(fileName, yearLearn, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по рейтингу олимпиад</p>
	 * @summary Данные по рейтингу олимпиад
	 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getRatingOlympiad(olympIds: string[], options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getRatingOlympiad(olympIds, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по рейтингу БКАД</p>
	 * @summary Данные по рейтингу БКАД
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getRatingSafenet(options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getRatingSafenet(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по результатам олимпиад(включая перечневые)</p>
	 * @summary Данные по результатам олимпиад(включая перечневые)
	 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getResultOlympiads(olympIds: string[], options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getResultOlympiads(olympIds, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета со статистикой олимпиады по классам</p>
	 * @summary Выгрузка отчета со статистикой олимпиады по классам
	 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
	 * @param {Api.GetResultOlympiadsByGradesXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
	 *   <ul>
	 *   <li><code>1</code>: Первый тур завершен.</li>
	 *   <li><code>2</code>: Второй тур завершен.</li>
	 *   </ul>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getResultOlympiadsByGradesXlsx(olympIds: string[], status: Api.GetResultOlympiadsByGradesXlsxStatusEnum | undefined, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getResultOlympiadsByGradesXlsx(olympIds, status, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета со статистикой олимпиады по регионам</p>
	 * @summary Выгрузка отчета со статистикой олимпиады по регионам
	 * @param {string[]} olympIds <p>Список идентификаторов олимпиад</p>
	 * @param {Api.GetResultOlympiadsXlsxStatusEnum} [status] <p>Статус олимпиады.</p>
	 *   <ul>
	 *   <li><code>1</code>: Первый тур завершен.</li>
	 *   <li><code>2</code>: Второй тур завершен.</li>
	 *   </ul>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getResultOlympiadsXlsx(olympIds: string[], status: Api.GetResultOlympiadsXlsxStatusEnum | undefined, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getResultOlympiadsXlsx(olympIds, status, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Сводные данные по олимпиадам за выбранный год</p>
	 * @summary Сводные данные по олимпиадам за выбранный год
	 * @param {string} yearLearn <p>учебный код в формате &quot;2020/2021&quot;</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTotalStatistic(yearLearn: string, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getTotalStatistic(yearLearn, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Данные по олимпиадам</p>
	 * @summary Данные по олимпиадам
	 * @param {string[]} [statuses] <p>Список статусов олимпиад (passed, current, future)</p>
	 * @param {string[]} [years] <p>Список годов (например, 2021, 2022)</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getUnAuthOlympiads(statuses: string[] | undefined, years: string[] | undefined, options?: RequestInit) {
		return OlympiadsApiFp(this.configuration).getUnAuthOlympiads(statuses, years, options)(this.fetch, this.basePath);
	}

}
/**
 * ParallelsSubjectsApi - fetch parameter creator
 * @export
 */
export const ParallelsSubjectsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParallelsSubjectsData(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/parallels_subjects`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ParallelsSubjectsApi - functional programming interface
 * @export
 */
export const ParallelsSubjectsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getParallelsSubjectsData(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetParallelsSubjectsData200Response> {
			const localVarFetchArgs = ParallelsSubjectsApiFetchParamCreator(configuration).getParallelsSubjectsData(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * ParallelsSubjectsApi - factory interface
 * @export
 */
export const ParallelsSubjectsApiFactory: FactoryFunction<ParallelsSubjectsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new ParallelsSubjectsApi(configuration, basePath, fetch);
};

/**
 * ParallelsSubjectsApi - object-oriented interface
 * @export
 * @class ParallelsSubjectsApi
 * @extends {BaseAPI}
 */
export class ParallelsSubjectsApi extends BaseAPI {
	/**
	 * <p>Параметры по умолчанию для выпадашек</p>
	 * @summary Параметры по умолчанию для выпадашек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getParallelsSubjectsData(options?: RequestInit) {
		return ParallelsSubjectsApiFp(this.configuration).getParallelsSubjectsData(options)(this.fetch, this.basePath);
	}

}
/**
 * PretendsApi - fetch parameter creator
 * @export
 */
export const PretendsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Претенд</p>
		 * @summary Претенд
		 * @param {Api.PretendsRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		pretends(request: Api.PretendsRequest, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling pretends.');
			}
			let localVarPath = `/api/v1/pretends`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Разпретенд</p>
		 * @summary Разпретенд
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		stopPretends(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/pretends`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * PretendsApi - functional programming interface
 * @export
 */
export const PretendsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Претенд</p>
		 * @summary Претенд
		 * @param {Api.PretendsRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		pretends(request: Api.PretendsRequest, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = PretendsApiFetchParamCreator(configuration).pretends(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						return response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Разпретенд</p>
		 * @summary Разпретенд
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		stopPretends(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = PretendsApiFetchParamCreator(configuration).stopPretends(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						return response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * PretendsApi - factory interface
 * @export
 */
export const PretendsApiFactory: FactoryFunction<PretendsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new PretendsApi(configuration, basePath, fetch);
};

/**
 * PretendsApi - object-oriented interface
 * @export
 * @class PretendsApi
 * @extends {BaseAPI}
 */
export class PretendsApi extends BaseAPI {
	/**
	 * <p>Претенд</p>
	 * @summary Претенд
	 * @param {Api.PretendsRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public pretends(request: Api.PretendsRequest, options?: RequestInit) {
		return PretendsApiFp(this.configuration).pretends(request, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Разпретенд</p>
	 * @summary Разпретенд
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public stopPretends(options?: RequestInit) {
		return PretendsApiFp(this.configuration).stopPretends(options)(this.fetch, this.basePath);
	}

}
/**
 * SchoolsApi - fetch parameter creator
 * @export
 */
export const SchoolsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
		 * @summary Статистика активности по школам (муниципалитетам)
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatistics(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/activities`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
		 * @summary Статистика aктивности учеников на сервисах Учи.ру
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsBySchoolSubjects(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/statistics/by_school_subjects`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета по предметам</p>
		 * @summary Выгрузка отчета по предметам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsBySchoolSubjectsXlsx(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/statistics/by_school_subjects_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка списка активных школ</p>
		 * @summary Выгрузка списка активных школ
		 * @param {string} endDate <p>конец периода</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsXlsx(endDate: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'endDate' is not null or undefined
			if (endDate === null || endDate === undefined) {
				throw new RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getActivityStatisticsXlsx.');
			}
			let localVarPath = `/api/v3/subjects/schools/activities/report_xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (endDate !== undefined) {
				localVarQueryParameter.append('end_date', String(endDate));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Количетсва активных и зарегистрированных учителей и школ</p>
		 * @summary Общие показатели
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getSchoolTotals(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/totals`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Активные и зарегистрированные учителя, ученики, нарастающий итог и распределение по месяцам</p>
		 * @summary Статистика по месяцам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatisticsByMonths(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/statistics/by_months`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Активные и зарегистрированные учителя, ученики, кол-во классов распределение по паралеллям</p>
		 * @summary Статистика по паралеллям
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatisticsByParallels(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v3/subjects/schools/statistics/by_parallels`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * SchoolsApi - functional programming interface
 * @export
 */
export const SchoolsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
		 * @summary Статистика активности по школам (муниципалитетам)
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatistics(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.ActivityStatistics> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getActivityStatistics(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
		 * @summary Статистика aктивности учеников на сервисах Учи.ру
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsBySchoolSubjects(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.ActivityStatisticsBySchoolSubjects> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getActivityStatisticsBySchoolSubjects(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета по предметам</p>
		 * @summary Выгрузка отчета по предметам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsBySchoolSubjectsXlsx(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getActivityStatisticsBySchoolSubjectsXlsx(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка списка активных школ</p>
		 * @summary Выгрузка списка активных школ
		 * @param {string} endDate <p>конец периода</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getActivityStatisticsXlsx(endDate: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getActivityStatisticsXlsx(endDate, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Количетсва активных и зарегистрированных учителей и школ</p>
		 * @summary Общие показатели
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getSchoolTotals(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetSchoolTotals200Response> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getSchoolTotals(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Активные и зарегистрированные учителя, ученики, нарастающий итог и распределение по месяцам</p>
		 * @summary Статистика по месяцам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatisticsByMonths(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.StatisticByMonth> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getStatisticsByMonths(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Активные и зарегистрированные учителя, ученики, кол-во классов распределение по паралеллям</p>
		 * @summary Статистика по паралеллям
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatisticsByParallels(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.StatisticByParallel> {
			const localVarFetchArgs = SchoolsApiFetchParamCreator(configuration).getStatisticsByParallels(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * SchoolsApi - factory interface
 * @export
 */
export const SchoolsApiFactory: FactoryFunction<SchoolsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new SchoolsApi(configuration, basePath, fetch);
};

/**
 * SchoolsApi - object-oriented interface
 * @export
 * @class SchoolsApi
 * @extends {BaseAPI}
 */
export class SchoolsApi extends BaseAPI {
	/**
	 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
	 * @summary Статистика активности по школам (муниципалитетам)
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getActivityStatistics(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getActivityStatistics(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
	 * @summary Статистика aктивности учеников на сервисах Учи.ру
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getActivityStatisticsBySchoolSubjects(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getActivityStatisticsBySchoolSubjects(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета по предметам</p>
	 * @summary Выгрузка отчета по предметам
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getActivityStatisticsBySchoolSubjectsXlsx(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getActivityStatisticsBySchoolSubjectsXlsx(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка списка активных школ</p>
	 * @summary Выгрузка списка активных школ
	 * @param {string} endDate <p>конец периода</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getActivityStatisticsXlsx(endDate: string, options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getActivityStatisticsXlsx(endDate, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Количетсва активных и зарегистрированных учителей и школ</p>
	 * @summary Общие показатели
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getSchoolTotals(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getSchoolTotals(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Активные и зарегистрированные учителя, ученики, нарастающий итог и распределение по месяцам</p>
	 * @summary Статистика по месяцам
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getStatisticsByMonths(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getStatisticsByMonths(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Активные и зарегистрированные учителя, ученики, кол-во классов распределение по паралеллям</p>
	 * @summary Статистика по паралеллям
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getStatisticsByParallels(options?: RequestInit) {
		return SchoolsApiFp(this.configuration).getStatisticsByParallels(options)(this.fetch, this.basePath);
	}

}
/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Проверка логина</p>
		 * @summary Проверка логина
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		checkAuth(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/user`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Логин</p>
		 * @summary Логин
		 * @param {Api.LoginRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		login(request: Api.LoginRequest, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling login.');
			}
			let localVarPath = `/api/v1/login`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Разлогин</p>
		 * @summary Разлогин
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		logout(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/v1/logout`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Проверка логина</p>
		 * @summary Проверка логина
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		checkAuth(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.CheckAuth200Response> {
			const localVarFetchArgs = UserApiFetchParamCreator(configuration).checkAuth(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Логин</p>
		 * @summary Логин
		 * @param {Api.LoginRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		login(request: Api.LoginRequest, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.Login200Response> {
			const localVarFetchArgs = UserApiFetchParamCreator(configuration).login(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 401) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Разлогин</p>
		 * @summary Разлогин
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		logout(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.Logout200Response> {
			const localVarFetchArgs = UserApiFetchParamCreator(configuration).logout(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory: FactoryFunction<UserApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new UserApi(configuration, basePath, fetch);
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
	/**
	 * <p>Проверка логина</p>
	 * @summary Проверка логина
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public checkAuth(options?: RequestInit) {
		return UserApiFp(this.configuration).checkAuth(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Логин</p>
	 * @summary Логин
	 * @param {Api.LoginRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public login(request: Api.LoginRequest, options?: RequestInit) {
		return UserApiFp(this.configuration).login(request, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Разлогин</p>
	 * @summary Разлогин
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public logout(options?: RequestInit) {
		return UserApiFp(this.configuration).logout(options)(this.fetch, this.basePath);
	}

}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
	if (value instanceof Date) {
		return value.toISOString();
	} else if (typeof value === 'string') {
		return value;
	} else {
		return undefined;
	}
}
